/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CspServiceRole } from './cspServiceRole';


export interface CspServiceRoleGroup { 
    /**
     * Service definition ID
     */
    serviceDefinitionId?: string;
    /**
     * Service roles
     */
    roles?: Array<CspServiceRole>;
}

